export class TreatmentGroupHDDetModel {

      tgcode = '' ;
tgdetitcode = '' ;
tgdetitname = '' ;
tgdetdose = '' ;
tgdetqty = '' ;
tgdetrote = '' ;
tgdetduration = '' ;
tgdetnotes = '' ;
compcode = '' ;
userid = '' ;
}
